// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UKhn","col":"styles_col__2HHKC"};